export enum actionTypes {
  LOGOUT_REQUEST = "LOGOUT_REQUEST",
  LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
  LOGOUT_FAIL = "LOGOUT_FAIL",
}
export enum stateStatusType {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export interface LogOutProps {
  message?: string;
}

export interface LogoutRequestAction {
  type: actionTypes.LOGOUT_REQUEST;
}
export interface LogoutSuccessAction {
  type: actionTypes.LOGOUT_SUCCESS;
  payload:string
}

export interface LogoutFailAction {
  type: actionTypes.LOGOUT_FAIL;
  payload: string;
}

export type LogoutActions =
  | LogoutRequestAction
  | LogoutSuccessAction
  | LogoutFailAction;
